export interface ILoginParams {
    email: string;
    password: string;
    rememberMe: boolean;
    isApplication: boolean;
    appVersion: string;
}
